<template>
  <Teleport to="body">
    <Transition name="cookie-slide">
      <div
        v-if="visible"
        class="fixed bottom-0 left-0 right-0 z-[90] flex justify-center px-4 pb-4"
      >
        <div class="w-full max-w-[430px] bg-ink rounded-2xl px-5 py-4 shadow-xl flex flex-col gap-3">
          <p class="text-13 text-cream leading-snug">
            Мы используем файлы cookie, чтобы гарантировать вам максимальное удобство.
            Продолжая пользоваться сайтом, вы даёте согласие на их использование.
          </p>
          <button
            @click="dismiss"
            class="self-end px-5 py-2 rounded-xl bg-cream text-ink text-14 font-semibold"
          >
            Понятно
          </button>
        </div>
      </div>
    </Transition>
  </Teleport>
</template>

<script setup>
import { ref, watch } from 'vue'
import { Capacitor } from '@capacitor/core'
import { useAuthStore } from '../store/auth.js'

const authStore = useAuthStore()
const visible = ref(false)

const COOKIE_KEY = 'zoya-cookie-accepted'

watch(() => authStore.user, (newUser) => {
  const isStandalone = window.matchMedia('(display-mode: standalone)').matches || window.navigator.standalone
  // Внутри Telegram Mini App баннер не нужен: это не браузерная вкладка, а
  // приложение внутри Telegram — там уже действуют его правила, и по той же
  // причине баннер скрыт в нативных сборках и в установленной PWA.
  if (newUser && !Capacitor.isNativePlatform() && !isStandalone
      && !authStore.isTelegramApp && !localStorage.getItem(COOKIE_KEY)) {
    setTimeout(() => { visible.value = true }, 5000)
  }
}, { immediate: true })

function dismiss() {
  visible.value = false
  localStorage.setItem(COOKIE_KEY, '1')
}
</script>

<style scoped>
.cookie-slide-enter-active, .cookie-slide-leave-active {
  transition: transform 0.3s ease, opacity 0.3s ease;
}
.cookie-slide-enter-from, .cookie-slide-leave-to {
  transform: translateY(100%);
  opacity: 0;
}
</style>
